/** Apply same VIEW / CREATE / EDIT / VIEW_COMMERCIAL_DATA hierarchy as backend PermissionService. */
export function normalizePermissionSet(codes) {
  const set = new Set(
    (codes || []).map((c) => String(c || '').trim().toUpperCase()).filter(Boolean)
  );
  if (set.has('CREATE') || set.has('EDIT')) {
    set.add('VIEW');
  }
  if (set.has('CREATE')) {
    set.add('VIEW_COMMERCIAL_DATA');
  }
  if (!set.has('VIEW')) {
    set.delete('CREATE');
    set.delete('EDIT');
    set.delete('VIEW_COMMERCIAL_DATA');
  }
  return set;
}

export function moduleGrantsView(permissions, moduleKey) {
  if (!moduleKey || !permissions) {
    return false;
  }
  const codes = permissions[moduleKey] || permissions[moduleKey.toUpperCase()];
  if (!codes) {
    return false;
  }
  const normalized = normalizePermissionSet(Array.isArray(codes) ? codes : [...codes]);
  return normalized.has('VIEW');
}

export function moduleGrantsAction(permissions, moduleKey, action) {
  if (!moduleKey || !permissions) {
    return false;
  }
  const codes = permissions[moduleKey] || permissions[moduleKey.toUpperCase()];
  if (!codes) {
    return false;
  }
  const normalized = normalizePermissionSet(Array.isArray(codes) ? codes : [...codes]);
  const act = String(action || 'VIEW').trim().toUpperCase();
  return normalized.has(act);
}
